var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kt-span',{staticClass:"kt-nav__link-badge"},[_c('kt-span',{staticClass:"kt-badge kt-badge--$variant kt-badge--pill",class:{'kt-badge--inline kt-badge--rounded': _vm.is_inline}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }